module.exports = __webpack_public_path__ + "static/media/ic_recharge.328df757.png";